<div class="deep-link-buttons-container" [ngClass]="containerClass">
  @if (showScrollArrows && showLeftArrow) {
    <button
      class="scroll-arrow scroll-arrow-left"
      (click)="scrollLeft()"
      [ngClass]="{ 'rounded-corners': roundedCorners }"
    >
      <ui-icon name="arrow-left-01" variant="stroke" />
    </button>
  }
  <div
    class="deep-link-buttons"
    #deepLinkButtons
    (scroll)="checkScrollArrows()"
  >
    @for (button of buttons; track button.label) {
      @if (shouldShowButton(button)) {
        <button
          class="deep-link-btn"
          [class.active]="button === activeButton"
          (click)="onButtonClick(button)"
        >
          @if (button.icon) {
            <ui-icon [name]="button.icon" variant="stroke" />
          }
          <span>{{ button.label | translate }}</span>
        </button>
      }
    }
  </div>
  @if (showScrollArrows && showRightArrow) {
    <button
      class="scroll-arrow scroll-arrow-right"
      (click)="scrollRight()"
      [ngClass]="{ 'rounded-corners': roundedCorners }"
    >
      <ui-icon name="arrow-right-01" variant="stroke" />
    </button>
  }
</div>
